<!-- MODAL Agregar Combo -->
<div mdbModal #agregarCombo="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          <ng-container *ngIf="mode === 'ADD'">
            Agregar combo
          </ng-container>
          <ng-container *ngIf="mode === 'EDIT'">
            Editar combo
          </ng-container>
          <ng-container *ngIf="mode === 'VIEW'">
            Ver combo
          </ng-container>
        </h4>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body" [ngClass]="{'disabledContent': mode === 'VIEW'}">
        <!-- Cabecera de botones -->

        <div class="filtros">
          <form [formGroup]="formHeader">
            <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
              <div class="">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Seleccionar clientes
                </h5>
              </div>
              <div></div>
            </div>
            <div class="row filtros-body">
              <div class="col" style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                ">
                <strong>Buscar por: </strong>
                <!-- Material inline 1 -->
                <div class="form-check form-check-inline">
                  <input type="radio" class="form-check-input" id="tab_combos_modal_rbBuscarPor_cliente"
                    formControlName="buscarPor" [value]="TIPO_TIPO_CLIENTE" mdbInput />
                  <!-- (change)='limpiarBuscarPorCliente()' -->
                  <label class="form-check-label" for="tab_combos_modal_rbBuscarPor_cliente">Tipo cliente</label>
                </div>

                <!-- Material inline 2 -->
                <div class="form-check form-check-inline">
                  <input type="radio" class="form-check-input" id="tab_combos_modal_rbBuscarPor_tipo_cliente"
                    formControlName="buscarPor" [value]="TIPO_CLIENTE" mdbInput />
                  <!-- (change)='limpiarBuscarPorTiposClientes()' -->
                  <label class="form-check-label" for="tab_combos_modal_rbBuscarPor_tipo_cliente">Cliente</label>
                </div>

                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="abrirModalSeleccion()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>

                <ng-container *ngIf="formHeader.get('buscarPor').value === TIPO_CLIENTE">
                  <button mdbBtn type="button" class="" color="info" mdbWavesEffect [ngClass]="{'enabledContent': true}"
                    (click)="abrirModalSeleccionarClienteSeleccionados()" *ngIf="clientesSeleccionados?.length > 0">
                    ({{clientesSeleccionados.length | numerico}}) Seleccionados
                  </button>
                </ng-container>
                <ng-container *ngIf="formHeader.get('buscarPor').value === TIPO_TIPO_CLIENTE">
                  <button mdbBtn type="button" class="" color="info" mdbWavesEffect [ngClass]="{'enabledContent': true}"
                    (click)="abrirModalSeleccionarTiposClienteSeleccionados()"
                    *ngIf="tiposClientesSeleccionados?.length > 0">
                    ({{tiposClientesSeleccionados.length | numerico}}) Seleccionados
                  </button>
                </ng-container>

                <!-- <h6 class="text-info" style="cursor: pointer; pointer-events: all; opacity: 1;"
                  (click)="verClientesSeleccionados()" *ngIf="clientesSeleccionados">
                  Ver Clientes
                </h6> -->
                <!-- <h6 class="text-info" *ngIf="clientesSeleccionados">
                  {{ clientesSeleccionadosFormatted }}
                </h6> -->
                <!-- <h6 class="text-info" *ngIf="tiposClientesSeleccionados">
                  {{ tiposClientesSeleccionadosFormatted }}
                </h6> -->
                <h6 *ngIf="
                  formHeader.get('clienteOrTipos').invalid &&
                  (formHeader.get('clienteOrTipos').dirty ||
                  formHeader.get('clienteOrTipos').touched)
                ">
                  <mdb-error *ngIf="formHeader.get('clienteOrTipos').hasError('required')">Ingrese cliente o tipo(s) de
                    cliente(s)
                  </mdb-error>
                </h6>
              </div>

              <div class="col">
                <div class="row">
                  <div class="col" style="display: flex; align-items: center;">
                    <div class="switch info-switch">
                      <label>
                        Inactivo
                        <input type="checkbox" color="info" formControlName="activo" />
                        <span class="lever"></span> Activo
                      </label>
                    </div>
                  </div>

                  <div class="col">
                    <div class="md-form">
                      <mdb-date-picker #datePickerInicio [inline]="true" name="fechaInicio"
                        [placeholder]="'Fecha inicio'" required formControlName='fechaInicio'>
                      </mdb-date-picker>
                      <div *ngIf="
                        formHeader.get('fechaInicio').invalid &&
                        (formHeader.get('fechaInicio').dirty ||
                        formHeader.get('fechaInicio').touched)
                      ">
                        <mdb-error *ngIf="formHeader.get('fechaInicio').hasError('required')">Ingrese fecha inicio
                        </mdb-error>
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div class="md-form">
                      <mdb-date-picker #datePickerFinal [inline]="true" name="fechaFinal" [placeholder]="'Fecha final'"
                        required formControlName='fechaFin'>
                      </mdb-date-picker>
                      <div *ngIf="
                        formHeader.get('fechaFin').invalid &&
                        (formHeader.get('fechaFin').dirty ||
                        formHeader.get('fechaFin').touched)
                      ">
                        <mdb-error *ngIf="formHeader.get('fechaFin').hasError('required')">Ingrese fecha fin
                        </mdb-error>
                      </div>
                    </div>
                  </div>

                  <ng-container *ngIf="permiteUnidadNegocio">
                    <div class="col">
                      <div class="md-form">
                        <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio"
                          placeholder="Unidad de negocio" [filterEnabled]="true"
                          formControlName="unidad_negocio_codigo">
                        </mdb-select>
                        <div *ngIf="
                        formHeader.get('unidad_negocio_codigo').invalid &&
                        (formHeader.get('unidad_negocio_codigo').dirty ||
                        formHeader.get('unidad_negocio_codigo').touched)
                      ">
                          <mdb-error *ngIf="formHeader.get('unidad_negocio_codigo').hasError('required')">Ingrese unidad
                            de negocio
                          </mdb-error>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="codigoProductoNuevo" class="form-control" placeholder="" required
                    formControlName="codigoProductoNuevo" #codigoProductoNuevo />
                  <label for="codigoProductoNuevo">Código de producto</label>
                  <div *ngIf="
                    formHeader.get('codigoProductoNuevo').invalid &&
                    (formHeader.get('codigoProductoNuevo').dirty ||
                    formHeader.get('codigoProductoNuevo').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('codigoProductoNuevo').hasError('required')">Ingrese código de
                      producto
                    </mdb-error>
                    <mdb-error *ngIf="formHeader.get('codigoProductoNuevo').hasError('min')">Código de producto debe ser
                      mayor a 0 </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="precioProducto" class="form-control" placeholder="" required
                    formControlName="precio" #precioProducto monto />
                  <label for="precioProducto">Precio $</label>
                  <div *ngIf="
                    formHeader.get('precio').invalid &&
                    (formHeader.get('precio').dirty ||
                    formHeader.get('precio').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('precio').hasError('required')">Ingrese precio
                    </mdb-error>
                    <mdb-error *ngIf="formHeader.get('precio').hasError('min')">Precio debe ser mayor a 0
                    </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="descripcionProducto" class="form-control" placeholder="" required
                    formControlName="descripcion" #descripcionProducto />
                  <label for="descripcionProducto">Descripción</label>

                  <div *ngIf="
                    formHeader.get('descripcion').invalid &&
                    (formHeader.get('descripcion').dirty ||
                    formHeader.get('descripcion').touched)
                  ">
                    <mdb-error *ngIf="formHeader.get('descripcion').hasError('required')">Ingrese descripción
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form [formGroup]='formDetails' (ngSubmit)="agregarItemCombo()" novalidate>
            <div class="row" style="border-bottom: 1px solid #dee2e6;">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Producto
                </h5>
              </div>
            </div>

            <div class="row filtros-body">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="codigoProductoItem" class="form-control" placeholder="" required
                    formControlName="codigoProductoItem" #codigoProductoItem />
                  <label for="codigoProductoItem">Código de producto</label>
                  <div *ngIf="
                    formDetails.get('codigoProductoItem').invalid &&
                    (formDetails.get('codigoProductoItem').dirty ||
                    formDetails.get('codigoProductoItem').touched)
                  ">
                    <mdb-error *ngIf="formDetails.get('codigoProductoItem').hasError('required')">Ingrese código de
                      producto
                    </mdb-error>
                    <mdb-error *ngIf="formDetails.get('codigoProductoItem').hasError('min')">Código de producto debe ser
                      mayor a 0 </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col d-flex" style="display: flex; align-items: center;">
                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="abrirModalSeleccionarProducto()">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
                <h6 class="text-info" *ngIf="productoSeleccionado" style="display: contents;">
                  {{ productoSeleccionado.descripcion}}
                </h6>
              </div>

              <div class="col">
                <div class="md-form">
                  <mdb-select label="Formato" [options]="optionsFormato" placeholder="Formato" [filterEnabled]="true"
                    formControlName="formato">
                  </mdb-select>
                  <div *ngIf="
                    formDetails.get('formato').invalid &&
                    (formDetails.get('formato').dirty ||
                    formDetails.get('formato').touched)
                  ">
                    <mdb-error *ngIf="formDetails.get('formato').hasError('required')">Ingrese formato
                    </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="montoPorcentaje" class="form-control" placeholder=""
                    formControlName="cantidad" required #montoPorcentaje monto />
                  <label for="montoPorcentaje">Cantidad</label>
                  <div *ngIf="
                    formDetails.get('cantidad').invalid &&
                    (formDetails.get('cantidad').dirty ||
                    formDetails.get('cantidad').touched)
                  ">
                    <mdb-error *ngIf="formDetails.get('cantidad').hasError('required')">Ingrese cantidad
                    </mdb-error>
                    <mdb-error *ngIf="formDetails.get('cantidad').hasError('min')">Cantidad debe ser mayor a 0
                    </mdb-error>
                  </div>
                </div>
              </div>
              <!-- <div class="col">
                <div class="md-form">
                  <mdb-select label="Unidad de Medida" [options]="optionsUndMedida" placeholder="Unidad de Medida"
                    formControlName="unidadMedida" [filterEnabled]="true"></mdb-select>
                  <div *ngIf="
                      formDetails.get('unidadMedida').invalid &&
                      (formDetails.get('unidadMedida').dirty ||
                      formDetails.get('unidadMedida').touched)
                    ">
                    <mdb-error *ngIf="formDetails.get('unidadMedida').hasError('required')">Ingrese unidad de medida
                    </mdb-error>
                  </div>
                </div>
              </div> -->

            </div>

            <div class="row card-footer text-muted filtros-footer" style="
              border-top: 1px solid #dee2e6;
              border-bottom: 1px solid #dee2e6;
            ">
              <div></div>
              <button mdbBtn type="submit" color="indigo" mdbWavesEffect>
                Agregar
              </button>
            </div>
          </form>
        </div>

        <div class="table-responsive" style="margin-top: 20px;">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Descripción</th>
                <th scope="col">Formato</th>
                <th scope="col">Cantidad</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let combo of listaProductosCombo; trackBy: trackByProductoCombo">
                <td>{{ combo.sku }}</td>
                <td>{{ combo.descripcion }}</td>
                <td>{{ combo.formatoGlosa }}</td>
                <td>{{ combo.cantidad | numerico }}</td>
                <td>
                  <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                    (click)="eliminarItemCombo(combo.index)">
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect (click)="guardar()"
          [disabled]="listaProductosCombo.length === 0" *ngIf="mode === 'ADD' || mode === 'EDIT'">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)" queryType="ONLY_RUT">
</app-modal-seleccionar-cliente>
<app-modal-seleccionar-cliente-tipos (onSelectMultiple)="onClienteTiposSeleccionado($event)">
</app-modal-seleccionar-cliente-tipos>


<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [origen]="MODAL_SEL_PROD_COMBO" [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
  (onNotFound)="onProductoNoEncontrado()" (onRemoteQuery)="getProductsByUnidadNegocio($event)">
</app-modal-seleccionar-producto>

<app-modal-show-clientes>
</app-modal-show-clientes>
